<template>
  <div>
    <hr class="my-3 gray" />

    <v-row
      v-if="discountAmount > 0"
      v-bind="{
        justify: 'between',
        align: 'center',
      }"
    >
      <v-col>
        <h3>
          {{ titleSpecialDiscount }}
        </h3>
      </v-col>
      <v-col class="text-right flex-0-nowrap">
        <h3 class="price-normal-text">
          - ฿{{ discountAmount | currency2 }}
        </h3>
      </v-col>
    </v-row>

    <v-row
      v-if="additionalDiscount > 0"
      v-bind="{
        justify: 'between',
        align: 'center',
      }"
    >
      <v-col>
        <h3>
          {{ additionalDiscountLabel }}
        </h3>
      </v-col>
      <v-col class="text-right flex-0-nowrap">
        <h3 class="price-normal-text">
          - ฿{{ additionalDiscount | currency2 }}
        </h3>
      </v-col>
    </v-row>

    <v-row
      v-if="couponCodes.length > 0"
      v-bind="{
        justify: 'between',
        align: 'center',
      }"
    >
      <v-col>
        <h3>คูปองที่ใช้</h3>
      </v-col>
      <v-col class="text-right">
        <h3 class="badge-coupon">
          - ฿{{ discountCouponAmount | currency2 }}
        </h3>
      </v-col>
      <v-col cols="12" class="pt-0">
        <v-chip
          v-for="(item, index) in couponCodes"
          :key="index"
          v-bind="{
            color: 'yellow lighten-4',
            textColor: 'black',
            closeIcon: 'mdi-close-circle-outline',
          }"
          small
          class="font-bold my-1 mr-1"
        >
          <v-icon small left color="yellow darken-2">
            mdi-ticket-confirmation
          </v-icon>

          {{ item.code }}
          <template v-if="item.discount_applied > 0">
            ส่วนลด -฿{{ item.discount_applied | currency2 }}
          </template>
        </v-chip>
      </v-col>
    </v-row>

    <hr class="my-3 gray" />

    <template v-if="advancePaymentOptional > 0">
      <v-row
        v-bind="{
          justify: 'between',
          align: 'center',
        }"
      >
        <v-col>
          <h3>
            ชำระเพิ่มเติม
          </h3>
        </v-col>
        <v-col class="text-right">
          <h3 class="price-normal-text">
            ฿{{ advancePaymentOptional | currency2 }}
          </h3>
        </v-col>
      </v-row>
    </template>

    <template v-if="isDeposit">
      <v-row
        v-bind="{
          justify: 'between',
          align: 'center',
        }"
      >
        <v-col cols="auto">
          <h3>ยอดมัดจำ (ชำระแล้ว)</h3>
        </v-col>
        <v-col class="text-right">
          <h3 class="price-normal-text">
            ฿{{ depositAmount | currency2 }}
          </h3>
        </v-col>
      </v-row>
    </template>

    <template v-if="guaranteeAmount > 0">
      <v-row
        v-bind="{
          justify: 'between',
          align: 'center',
        }"
      >
        <v-col>
          <h3>
            {{ guaranteeAmountLabel }}
          </h3>
        </v-col>
        <v-col class="text-right">
          <h3 class="price-summary-text">
            ฿{{ guaranteeAmount | currency2 }}
          </h3>
        </v-col>
      </v-row>
    </template>

    <template v-if="isDeposit && finalPrice > 0">
      <v-row
        v-bind="{
          justify: 'between',
          align: 'center',
        }"
      >
        <v-col>
          <h3>
            ยอดชำระคงเหลือ
          </h3>
        </v-col>
        <v-col class="text-right">
          <h3 class="price-summary-text">
            ฿{{ finalPriceDeposit | currency2 }}
          </h3>
        </v-col>

        <hr class="my-3 gray" />
      </v-row>
      <hr class="my-3 gray" />
    </template>

    <template v-if="totalPrice > 0">
      <v-row
        v-bind="{
          justify: 'between',
          align: 'center',
        }"
      >
        <v-col>
          <h3>ยอดรวมสุทธิ</h3>
        </v-col>
        <v-col class="text-right">
          <h3 class="price-normal-text flex-0-nowrap">
            ฿{{ totalPrice | currency2 }}
          </h3>
        </v-col>
      </v-row>
    </template>
  </div>
</template>

<script>
export default {
  name: 'CheckoutSummary',

  props: {
    discountAmount: {
      type: Number,
      default: 0,
    },
    titleSpecialDiscount: {
      type: String,
      default: 'ส่วนลด',
    },
    additionalDiscount: {
      type: Number,
      default: 0,
    },
    additionalDiscountLabel: {
      type: String,
      default: 'ส่วนลดเพิ่มเติม',
    },
    couponCodes: {
      type: Array,
      default: () => [],
    },
    discountCouponAmount: {
      type: Number,
      default: 0,
    },
    advancePaymentOptional: {
      type: Number,
      default: 0,
    },
    isDeposit: {
      type: Boolean,
      default: false,
    },
    depositAmount: {
      type: Number,
      default: 0,
    },
    guaranteeAmount: {
      type: Number,
      default: 0,
    },
    guaranteeAmountLabel: {
      type: String,
      default: 'ยอดค้ำประกันที่ต้องชำระ',
    },
    finalPrice: {
      type: Number,
      default: 0,
    },
    finalPriceDeposit: {
      type: Number,
      default: 0,
    },
    totalPrice: {
      type: Number,
      default: 0,
    },
  },
}
</script>

<style lang="stylus" scoped>
.price-normal-text
    color:  $color-normal-price

.price-summary-text
    color:  $color-text-price

.flex-0-nowrap
  flex: 0
  white-space: nowrap
</style>
